export default __webpack_public_path__ + "static/media/JindalLogo.29b7d260.png";